<template>
    <!-- v-if="bannerList.length > 0" -->
    <el-carousel
        height="515px"
        class="banner_wrap "
    >
        <el-carousel-item
            v-for="(item,index) in bannerList"
            :key="index"
            class="banner-item"
        >
            <div class="banner-item_wrap">
                <img
                    :src="item.image_url"
                    alt=""
                    class="img_banner"
                >
                <!-- <div class="title">
          <p>{{ tougaoSetting.organizer }}</p>
          <p>{{ tougaoInfo.title }}</p>
        </div> -->
            </div>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Banner',
    components: {},
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters(['bannerList', 'tougaoInfo', 'tougaoSetting'])
    },
    created() {
    },
    methods: {
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.banner_wrap {
    width: 100%;
    height: 100%;
    z-index: -1;
    background: #fff;

    .banner-item_wrap {
        width: 100%;
        height: 100%;
        position: relative;

        .img_banner {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: auto !important;
            height: 100%;
        }
    }

    .title {
        font-size: 42px;
        font-weight: bold;
        line-height: 56px;
        text-align: center;
        color: #fff;
        z-index: 99;
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);
    }
}

@media screen and (max-width: 1260px) {
    .banner_wrap {
        .title {
            font-size: 30px;
        }
    }
}
</style>
